module.exports = __webpack_public_path__ + "static/media/L12.02d5b3a4.jpg";